module.exports = __webpack_public_path__ + "img/menu.8684d03d.svg";